/**
 * Estilos compartidos para las categorías del glosario.
 *
 * Consolidado en prompt 351 tras detectarse duplicación entre `GlosarioPage.tsx`
 * (visor público) y `AdminGlosario.tsx` (panel admin). Una sola fuente de verdad
 * para colores por categoría.
 *
 * El `label` aquí es un fallback en español. Para i18n, consumir
 * `t.glosario.categoria.*` en el componente.
 */

import type { CategoriaTermino } from '../services/api';

export interface CategoriaStyle {
  color: string;
  bg: string;
  label: string;
}

export const CATEGORIA_STYLES: Record<CategoriaTermino, CategoriaStyle> = {
  INGENIERIA: { color: '#2F5496', bg: '#EFF6FF', label: 'Ingeniería' },
  TIPO_DOCUMENTAL: { color: '#059669', bg: '#ECFDF5', label: 'Tipo Documental' },
  GENERAL: { color: '#6B7280', bg: '#F3F4F6', label: 'General' },
  FASE: { color: '#C2410C', bg: '#FFF7ED', label: 'Fase' },
  ROL: { color: '#7C3AED', bg: '#F5F3FF', label: 'Rol' },
  TECNICO: { color: '#0369A1', bg: '#E0F2FE', label: 'Técnico' },
};

export const CATEGORIAS_ORDER: CategoriaTermino[] = [
  'INGENIERIA',
  'TIPO_DOCUMENTAL',
  'GENERAL',
  'FASE',
  'ROL',
  'TECNICO',
];
